import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { useParams } from "react-router-dom";
import { Grid, Paper, Avatar, TextField, Button } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import image from "../../../components/authentication/assets/img/trainer.jpg";
import styles from "../../../components/authentication/assets/jss/labs/views/loginPage.js";
import { RemoveScrollBar } from "react-remove-scroll-bar";
import Link from "@mui/material/Link";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import ReactLoading from "react-loading";

const useStyles = makeStyles(styles);

// function Progress(props) {
//   const { submitted, refreshPage } = props;

//   const delay = 3;

//   const [show, setShow] = useState(false);

//   useEffect(() => {
//     let timer1 = setTimeout(() => setShow(true), delay * 1000);
//     return () => {
//       clearTimeout(timer1);
//     };
//   }, []);
//   return show ? (
//     refreshPage()
//   ) : (
//     <React.Fragment>
//       <style>
//         {`
//           .loader {
//             background: #ffffff;
//             bottom: 0;
//             left: 0;
//             opacity: 0.8;
//             position: absolute;
//             right: 0;
//             top: 0;
//         }

//         .loader,
//         .loader-content {
//             display: flex;
//             align-items: center;
//             justify-content: center;
//         }

//         .loader-message {
//             font-size: 2.5em;
//             margin-top: 1em;
//         }
//         `}
//       </style>
//       <div className="loader">
//         <div className="loader-content">
//           <ReactLoading
//             type="spokes"
//             color="#000099"
//             height={500}
//             width={250}
//           />
//         </div>
//       </div>
//       <div className="loader">Loading ...</div>
//     </React.Fragment>
//   );
// }

function Progress() {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      zIndex: 9999
    }}>
      <ReactLoading
        type="spokes"
        color="#000099"
        height={100}
        width={50}
      />
    </div>
  );
}

const Login = () => {
  const classes = useStyles();
  const { orgname } = useParams();

  const paperStyle = {
    padding: 17,
    height: "50vh",
    width: 450,
    margin: "80px auto",
    background: "rgb(6, 57, 108)",
  };
  const avatarStyle = { backgroundColor: "#1bbd7e" };
  const btnstyle = {
    margin: "20px 0",
    margin: "20px 0px",
    background: "brown",
  };

  const [open, setOpen] = React.useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const [state, setState] = useState({
    email: "",
    password: "",
    errorMessage: "",
    submitted: false,
    handleChange: false,
  });

  // localStorage.clear();

  useEffect(() => {
    localStorage.clear();
  }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  function refreshPage() {
    window.location.reload();
  }

  // const handleSubmitClick = (e) => {
  //   setState({ handleChange: false });
  //   const login = {
  //     email: state.email,
  //     password: state.password,
  //   };
  //   setState({ submitted: true });
  //   fetch(`${process.env.REACT_APP_API_URL}/auth/login/`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(login),
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.tokens && data.email && data.username) {
  //         localStorage.setItem("user", data.username);
  //         localStorage.setItem("email", data.email);
  //         localStorage.setItem("group", data.group);
  //         localStorage.setItem("token", data.tokens.access);
  //         fetch(
  //           `${process.env.REACT_APP_API_URL}/api/user_management/user_list/`,
  //           {
  //             method: "GET",
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: "Bearer " + localStorage.getItem("token"),
  //             },
  //           }
  //         )
  //           .then((resp) => resp.json())
  //           .then((data) => {
  //             localStorage.setItem("user_access", data.detail);
  //             window.location.href = "/";
  //           });
  //       } else {
  //         setOpen(true);
  //         setState({ email: "" });
  //         setState({ password: "" });
  //         setState({ submitted: false });          
  //         if (data.email) {
  //           setState({ email: "" });
  //           setState({ password: "" });
  //           setState({ errorMessage: data.email[0] });
  //           setOpen(true);
  //         } else if (data.password) {
  //           setState({ email: "" });
  //           setState({ password: "" });
  //           setState({ errorMessage: data.password[0] });
  //           setOpen(true);
  //         } else if (data.password && data.email) {
  //           setState({ email: "" });
  //           setState({ password: "" });
  //           setState({ errorMessage: data.email[0] });
  //           setOpen(true);
  //         } else {
  //           setState({ email: "" });
  //           setState({ password: "" });
  //           setState({ errorMessage: data.detail });
  //           setOpen(true);
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       localStorage.removeItem("token");
  //     });
  // };

  const handleSubmitClick = async (e) => {
    if (e) e.preventDefault(); // Prevent form submission only if `e` exists

    setState((prev) => ({ ...prev, handleChange: false, submitted: true }));

    const login = {
      email: state.email,
      password: state.password,
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(login),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.detail || "Login failed");
      }

      if (data.tokens && data.email && data.username) {
        localStorage.setItem("user", data.username);
        localStorage.setItem("email", data.email);
        localStorage.setItem("group", data.group);
        localStorage.setItem("token", data.tokens.access);

        // Fetch user access
        // const userResponse = await fetch(
        //   `${process.env.REACT_APP_API_URL}/api/user_management/user_list/`,
        //   {
        //     method: "GET",
        //     headers: {
        //       "Content-Type": "application/json",
        //       Authorization: `Bearer ${data.tokens.access}`,
        //     },
        //   }
        // );

        // const userData = await userResponse.json();
        // localStorage.setItem("user_access", userData.detail);

        window.location.href = "/"; // Redirect to home
      } else {
        handleLoginError(data);
      }
    } catch (error) {
      console.error("Login error:", error);
      localStorage.removeItem("token");
      setState((prev) => ({
        ...prev,
        submitted: false,
        errorMessage: error.message || "Login failed",
      }));
      setOpen(true);
    }
  };

  // 🔹 Helper function to handle errors
  const handleLoginError = (data) => {
    let errorMessage = data.email?.[0] || data.password?.[0] || data.detail || "Invalid credentials";

    setState((prev) => ({
      ...prev,
      email: "",
      password: "",
      submitted: false,
      errorMessage,
    }));

    setOpen(true);
  };

  const handleKeypress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();  // 🔹 Prevents unwanted form submission behavior
      handleSubmitClick();
    }
  };

  const [avatar, setAvatar] = React.useState([]);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/orgavatar/${orgname}`, {
      method: "GET",
    })
      .then((resp) => resp.json())
      .then((resp) => setAvatar(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/orgavatar/${orgname}`)
      .then((resp) => resp.json())
      .then((resp) => setAvatar(resp))
      .catch(console.error);
  }, [orgname]);  // 🔹 Added dependency

  // return (
  //   <>
  //     <div
  //       style={{
  //         zoom: "100%",
  //       }}
  //     >
  //       <RemoveScrollBar />
  //       {!state.errorMessage && state.submitted ? (
  //         <Progress submitted={state.submitted} refreshPage={refreshPage} />
  //       ) : (
  //         <div
  //           className={`${classes.pageHeader} text-muted text-center mt-2 mb-3`}
  //           style={{
  //             backgroundImage: `url(${image})`,
  //             backgroundSize: "cover",
  //             display: "block",
  //             fontFamily: "Work Sans",
  //           }}
  //         >
  //           <div className={classes.container}>
  //             {state.errorMessage && !state.submitted && (
  //               <React.Fragment>
  //                 <Snackbar
  //                   anchorOrigin={{
  //                     vertical: "top",
  //                     horizontal: "right",
  //                   }}
  //                   open={open}
  //                   autoHideDuration={6000}
  //                   onClose={handleClose}
  //                   message="Note archived"
  //                   style={{
  //                     paddingTop: "60px",
  //                     paddingRight: "30px",
  //                     position: "fixed",
  //                   }}
  //                   action={
  //                     <React.Fragment>
  //                       <IconButton
  //                         size="small"
  //                         aria-label="close"
  //                         color="inherit"
  //                         onClick={handleClose}
  //                       >
  //                         <CloseIcon fontSize="small" />
  //                       </IconButton>
  //                     </React.Fragment>
  //                   }
  //                   maxSnack={3}
  //                 >
  //                   <Alert onClose={handleClose} severity="error">
  //                     {state.errorMessage}
  //                   </Alert>
  //                 </Snackbar>
  //               </React.Fragment>
  //             )}
  //             <Grid container justifyContent="center">
  //               <Paper elevation={12} style={paperStyle}>
  //                 <form onSubmit={handleSubmitClick} style={{ display: "flex", flexDirection: "column" }}>
  //                   <Grid align="center" sx={{ marginBottom: "10px" }}>
  //                     {avatar === "" || avatar === "Not Found!!!" ? (
  //                       <Avatar style={avatarStyle}>
  //                         <LockOutlinedIcon />
  //                       </Avatar>
  //                     ) : (
  //                       <Avatar
  //                         src={avatar.cover}
  //                         style={{ borderRadius: 0 }}
  //                         sx={{
  //                           cursor: "pointer",
  //                           width: 200,
  //                           height: 60,
  //                         }}
  //                       />
  //                     )}
  //                   </Grid>
  //                   <TextField
  //                     display="block"
  //                     marginRight="auto"
  //                     marginLeft="auto"
  //                     variant="outlined"
  //                     margin="normal"
  //                     required
  //                     fullWidth
  //                     id="email"
  //                     name="email"
  //                     autoComplete="email"
  //                     placeholder="Email"
  //                     autoFocus
  //                     value={state.email}
  //                     onChange={handleChange}
  //                     onKeyPress={handleKeypress}
  //                     style={{ background: "#ffffff" }}
  //                   />
  //                   <br />
  //                   <TextField
  //                     display="block"
  //                     marginRight="auto"
  //                     marginLeft="auto"
  //                     variant="outlined"
  //                     margin="normal"
  //                     required
  //                     fullWidth
  //                     name="password"
  //                     placeholder="Password"
  //                     type="password"
  //                     id="password"
  //                     style={{ background: "#ffffff" }}
  //                     autoComplete="current-password"
  //                     onChange={handleChange}
  //                     onKeyPress={handleKeypress}
  //                     value={state.password}
  //                     validate={{
  //                       pattern: {
  //                         value:
  //                           "^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+*!=]).*$",
  //                         errorMessage:
  //                           "Requires min 8 char, 1 upper case, 1 numeric and 1 special char",
  //                       },
  //                     }}
  //                   />

  //                   <Grid container spacing={2} justifyContent="space-between" sx={{ paddingTop: "0.5rem" }}>
  //                     <Grid item>
  //                       <Link
  //                         color="#ffffff"
  //                         href="/forgotpassword"
  //                         fontFamily="sans-serif"
  //                         fontSize="17px"
  //                       >
  //                         Forgot password?
  //                       </Link>
  //                     </Grid>
  //                     <Grid item>
  //                       <Link
  //                         color="#ffffff"
  //                         href="/connectivitytest"
  //                         fontFamily="sans-serif"
  //                         fontSize="17px"
  //                       >
  //                         Connectivity Test
  //                       </Link>
  //                     </Grid>
  //                   </Grid>


  //                   <div className="mt-5">
  //                     <Button
  //                       type="submit"
  //                       color="primary"
  //                       variant="contained"
  //                       style={btnstyle}
  //                       fullWidth
  //                       // onClick={handleSubmitClick}
  //                       disabled={state.submitted ? true : false}
  //                     >
  //                       Sign in
  //                     </Button>
  //                   </div>
  //                 </form>
  //                 <br />
  //               </Paper>
  //             </Grid>
  //           </div>
  //         </div>
  //       )}
  //     </div>
  //   </>
  // );
  return (
  <>
    <div style={{ zoom: "100%" }}>
      <RemoveScrollBar />
      {!state.errorMessage && state.submitted ? (
        <Progress submitted={state.submitted} refreshPage={refreshPage} />
      ) : (
        <div
          className={`${classes.pageHeader} text-muted text-center mt-2 mb-3`}
          style={{
            backgroundImage: `url(${image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "Work Sans",
          }}
        >
          <div className={classes.container}>
            {state.errorMessage && !state.submitted && (
              <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                style={{ paddingTop: "60px", paddingRight: "30px" }}
              >
                <Alert onClose={handleClose} severity="error">
                  {state.errorMessage}
                </Alert>
              </Snackbar>
            )}

            <Grid container justifyContent="center">
              <Paper
                elevation={12}
                style={{
                  padding: 24,
                  width: "90%",
                  maxWidth: 420,
                  background: "rgb(6, 57, 108)",
                  borderRadius: 10,
                }}
              >
                <form
                  onSubmit={handleSubmitClick}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <Grid align="center">
                    {avatar === "" || avatar === "Not Found!!!" ? (
                      <Avatar
                        style={{
                          backgroundColor: "#1bbd7e",
                          width: 60,
                          height: 60,
                        }}
                      >
                        <LockOutlinedIcon />
                      </Avatar>
                    ) : (
                      <Avatar
                        src={avatar.cover}
                        style={{ borderRadius: 0 }}
                        sx={{
                          width: { xs: 120, sm: 180, md: 200 },
                          height: { xs: 50, sm: 60 },
                          mb: { xs: 1, sm: 2 }, // adds margin below the logo
                          mt: { xs: 1, sm: 0 }, // adds a little top spacing on mobile
                          objectFit: "contain",
                        }}
                      />

                    )}
                  </Grid>

                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    id="email"
                    placeholder="Email"
                    value={state.email}
                    onChange={handleChange}
                    onKeyPress={handleKeypress}
                    style={{ background: "#ffffff" }}
                  />

                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    id="password"
                    placeholder="Password"
                    type="password"
                    value={state.password}
                    onChange={handleChange}
                    onKeyPress={handleKeypress}
                    style={{ background: "#ffffff" }}
                  />

                  <Grid
                    container
                    justifyContent="space-between"
                    sx={{
                      pt: 1,
                      flexDirection: { xs: "column", sm: "row" },
                      alignItems: "center",
                      gap: { xs: 1, sm: 0 },
                    }}
                  >
                    <Link
                      color="#ffffff"
                      href="/forgotpassword"
                      fontFamily="sans-serif"
                      fontSize="16px"
                    >
                      Forgot password?
                    </Link>
                    <Link
                      color="#ffffff"
                      href="/connectivitytest"
                      fontFamily="sans-serif"
                      fontSize="16px"
                    >
                      Connectivity Test
                    </Link>
                  </Grid>

                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    style={{
                      background: "brown",
                      marginTop: "12px",
                      padding: "10px",
                      fontSize: "16px",
                    }}
                    disabled={state.submitted}
                  >
                    Sign in
                  </Button>
                </form>
              </Paper>
            </Grid>
          </div>
        </div>
      )}
    </div>
  </>
);

};

export default Login;
